import { Layout } from "../components/funnel";
import { ApplyInfo } from "../components/apply/ApplyInfo";
import { ApplyCard } from "../components/apply/ApplyCard";

export default function ApplyPage() {
  return (
    <Layout chrome={false} footerVariant="compact">
      <section className="relative overflow-hidden" data-testid="apply-section">
        <div className="breathe-glow pointer-events-none absolute -left-40 top-0 h-[560px] w-[min(900px,140vw)]" aria-hidden="true" />
        <div className="gutter relative grid gap-12 py-14 sm:py-20 lg:grid-cols-[5fr_7fr] lg:gap-16 lg:py-24">
          <ApplyInfo />
          <ApplyCard />
        </div>
      </section>
    </Layout>
  );
}
